import { FC } from "react";

import Grid from "@mui/material/Grid";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";

interface FilledActionsProps {
  onReplace: () => void;
  onDelete: () => void;
  showDeleteButton: boolean;
  dataTest: string | undefined;
}

export const FilledActions: FC<FilledActionsProps> = ({ onReplace, onDelete, showDeleteButton, dataTest }) => {
  const { t } = useTranslate();

  return (
    <Grid item container height="100%" alignItems="center" justifyContent="center" spacing={2} padding={1}>
      <Grid item>
        <DashboardButton
          variant="outlined"
          vibe="neutral"
          onClick={onReplace}
          sx={{ backgroundColor: "white" }}
          data-test={`${dataTest}-replace-button`}
        >
          {t("common", "replaceImage")}
        </DashboardButton>
      </Grid>

      {showDeleteButton && (
        <Grid item>
          <DashboardButton
            variant="outlined"
            vibe="neutral"
            onClick={onDelete}
            sx={{ backgroundColor: "white" }}
            data-test={`${dataTest}-delete-button`}
          >
            {t("common", "deleteImage")}
          </DashboardButton>
        </Grid>
      )}
    </Grid>
  );
};
